export const AVAILABLE_MENUS_QUERY_KEY = "available-menus";
export const STORE_MENU_QUERY_KEY = "store-menu";
